import { InvoiceController } from '../../controllers';
import React, { useState, useEffect } from 'react';
import { MimaToastUtil } from '../../components';
import { useNavigate } from 'react-router-dom';
import { inventoryStore, invoiceStore } from '../../stores';
import { ProductCheckOut } from '../../pages';
import constant from '../../utils/constant';
import * as yup from 'yup';
import { phoneRegExp } from '../../utils/utils';

const ProductCheckOutContainer = () => {
	const [isToggle, setIsToggle] = useState(true);
	const [preCheckOutData, setPreCheckOutData] = useState({});
	const [pay, setPay] = useState(false);
	const [loading, setLoading] = useState(false);
	const history = useNavigate();

	useEffect(() => {
		const data = localStorage.getItem('stock');
		if (data !== null) setPreCheckOutData(JSON.parse(data));
	}, []);

	const toggleSummary = () => {
		setIsToggle(!isToggle);
	};

	const goBack = () => {
		if (pay) {
			setPay(false);
		}
	};

	const showPay = () => {
		setPay(true);
	};

	const navigate = useNavigate();

	const customerDetailsValidation = () => {
		return yup.object({
			fullname: yup.string().required('Your name is required'),
			mobile: yup.string().matches(phoneRegExp, 'Phone number is not valid').required('Your phone number is required'),
			email: yup.string().email().required('Your email is required'),
			country: yup.string().required('Your country is required'),
			state: yup.string().required('Your state is required'),
			//town: yup.string().required('Your town is required'),
			street: yup.string().required('Your street address is required'),
		});
	};

	const onSubmit = async customer => {
		setLoading(true);
		let payload = {
			invoice: {
				stocks: [
					{ stock: preCheckOutData._id, quantity: preCheckOutData.quantity },
				],
				business: inventoryStore.selectedStock?.business,
			},
			customer,
		};

		for (const key in payload) {
			if (payload[key] === '') {
				delete payload[key];
			}
		}
		const { status, errorMessage } = await InvoiceController.createStockInvoice(
			payload
		);

		if (status === constant.Success) {
			setLoading(false);

			MimaToastUtil.success({
				message: constant.Success,
			});
			return setPay(true);
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const invoice = invoiceStore.selectedInvoice;

	const goToMimaCheckout = ()=>{
		if (invoice.currencyCode === "NGN") {
			navigate(`/mima-checkout?invoiceId=${invoice._id}`);
		  } else {
			window.open(invoice.paymentUrl, "_self")
		  }
	}

	return (
		<ProductCheckOut
			isToggle={isToggle}
			history={history}
			toggleSummary={toggleSummary}
			pay={pay}
			goBack={goBack}
			showPay={showPay}
			loading={loading}
			onSubmit={onSubmit}
			customerDetailsValidation={customerDetailsValidation}
			preCheckOutData={preCheckOutData}
			goToMimaCheckout={goToMimaCheckout}
		/>
	);
};

export default ProductCheckOutContainer;
